export default "__VITE_ASSET__D3N2ff_D__"